import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL Game
export const gameList = (params = '') => Http.get(`/mundo-indie-project-status${serialize(params)}`)
export const gameCreate = (params = '') => Http.post('/mundo-indie-project-status', params)
export const gameByID = (params = '') => Http.get(`/mundo-indie-project-status/${params}`)
export const gameUpdate = (params = '') => Http.put(`/mundo-indie-project-status/${params.id}`, params)
export const gameDestroy = (params = '') => Http.delete(`/mundo-indie-project-status/${params.id}`)
